module.exports = __webpack_public_path__ + "img/one.1630993415105.png";